/*****************************************************************
   JAVASCRIPT
   - Imports
   - Mobile navigation
   - Sticky nav
   - Slick.js
   - Audio player
   - Home page popup drawer
*****************************************************************/


// Imports
// ------------------------------------------------------------
import $ from 'jquery'; // at some point jQuery should be stripped out
import stickybits from 'stickybits';
import './vendor/slick/slick';
import GreenAudioPlayer from './vendor/green-audio-player/gap';
import UIkit from 'uikit';
import {hasClass} from "uikit/src/js/util";



// Mobile navigation
// ------------------------------------------------------------

const $navMenu = $('.nav__menu');
const $jsMenu = $('.js-menu');
const $socialContainer = $('#social-container');
$('.js-nav-toggle').on('click', function() {
   if($jsMenu.hasClass('is-open')){
      closeMenu();
   }
   else {
      openMenu();
   }
});

function closeMenu(){
   $("body").removeClass('fixed');
   $jsMenu.removeClass('is-open');
   $socialContainer.show();
   $navMenu.removeClass('is-open');
}

function openMenu(){
   $("body").addClass('fixed');
   $jsMenu.addClass('is-open');
   $socialContainer.hide();
   $navMenu.addClass('is-open')
}

const closeMenuButton = $('.close-menu-button');

closeMenuButton.on('click', function(){
   closeMenu();
})

function is_touch_enabled() {
   return ( 'ontouchstart' in window ) ||
          ( navigator.maxTouchPoints > 0 ) ||
          ( navigator.msMaxTouchPoints > 0 );
}

if ( is_touch_enabled() ) {
   // Show overview links
   // console.log('TAPPY TAP!');
   $('.overview.mobile-hidden').addClass('hide');
   $('.sublinks').removeClass('is-open').slideUp();

   $('.has-sublinks > a').on('click', function(e) {
      e.preventDefault();

      var currentLink = $(this).next('.sublinks');

      $('.sublinks').slideUp();

      if ( $(currentLink).is(':visible') ) {
         $(currentLink).slideUp();
      }
      else {
         $(currentLink).slideDown();
      }
   });

   const $menu = $('.sublinks');
   $(document).on('mouseup', function(e) {
      if (!$menu.is(e.target)                // if the target of the click isn't the submenu...
      && $menu.has(e.target).length === 0)   // ... nor a descendant of the submenu
      {
         $menu.removeClass('is-open');
      }
   });
}
else {
   // Hide overview links
   $('.sublinks').addClass('is-open');
}

// Donate dropdown
$('.js-donate-toggle').on('click', function() {
   $(this).toggleClass('is-open');
   $('.js-donate-dropdown').toggleClass('is-open');
});



// Video modals: unload the iframe while the modal closes. uk-video only pauses
// it, and a paused player still answers the keyboard's media Play key. Worse,
// UIkit re-runs uk-video's autoplay as the close fade starts, which briefly
// resumes a paused video. Blanking the src first makes uk-video skip it; the
// real src goes back once the modal is hidden, ready for the next open.
// Covers Escape and backdrop clicks too.
function restoreModalIframes(e) {
	if (e.target !== this) {
		return;
	}
	$(this).find('iframe').each(function () {
		const src = $(this).data('src');
		if (src && this.src === 'about:blank') {
			this.src = src;
		}
	});
}

$(document).on('beforehide', '.uk-modal', function (e) {
	if (e.target !== this) {
		return;
	}
	$(this).find('iframe').each(function () {
		$(this).data('src', this.src);
		this.src = 'about:blank';
	});
}).on('hidden beforeshow', '.uk-modal', restoreModalIframes);

// Sticky nav
// ------------------------------------------------------------
// stickybits('.js-sticky', {
//   // useStickyClasses: true
// });


// Slick.js
// ------------------------------------------------------------
if ($('.js-gallery').length) {
	$('.js-gallery').slick({
	infinite: true,
	prevArrow: '<button type="button" class="slick-prev"><span class="far fa-arrow-left"></span></button>',
	nextArrow: '<button type="button" class="slick-next"><span class="far fa-arrow-right"></span></button>',
	slidesToShow: 3,
	slidesToScroll: 3,
	responsive: [
		{
			breakpoint: 1024, // and below
			settings: {
			slidesToShow: 3,
			slidesToScroll: 3
			}
		},
		{
			breakpoint: 768, // and below
			settings: {
			slidesToShow: 2,
			slidesToScroll: 2
			}
		},
		{
			breakpoint: 480, // and below
			settings: {
			slidesToShow: 1,
			slidesToScroll: 1
			}
		}
	]
	});
}

if ($('.js-large-slider').length) {
    $('.js-large-slider').slick({
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev"><span class="far fa-arrow-left"></span></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="far fa-arrow-right"></span></button>',
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
            {
                breakpoint: 1330, // and below
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 768, // and below
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480, // and below
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

if ($('.stories-slider').length) {
	$('.stories-slider').slick({
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><span class="far fa-arrow-left"></span> <span class="sr-only">Previous</span></button>',
		nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span> <span class="far fa-arrow-right"></span></button>',
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 1024, // and below
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 768, // and below
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480, // and below
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}

if ($('.js-home-article-slider').length) {
    $('.js-home-article-slider').slick({
        infinite: true,
        dots: true,
        // prevArrow: '<button type="button" class="slick-prev"><span >1</span></button>',
        // nextArrow: '<button type="button" class="slick-next"><span>2</span></button>',
        slidesToShow: 2,
        slidesToScroll: 2,
        variableWidth: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1068, // and below
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 860, // and below
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 776, // and below
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
        customPaging : function(slider, i) {
            var thumb = jQuery(slider.$slides[i]).data();
            // return '<a>'+(i+1)+'</a>'; // <-- old
            return i + 1; // <-- new
        }
    });
}


// Audio player
// ------------------------------------------------------------
if($('.c-audio__player').length) {
   // new GreenAudioPlayer('.audio-player');

   GreenAudioPlayer.init({
      selector: '.c-audio__player', // inits Green Audio Player on each audio container that has class "player"
      stopOthersOnPlay: true
   });
}



// Home page popup drawer
// ------------------------------------------------------------
if(document.getElementsByClassName("popup-drawer")) {
   var popup = document.querySelector(".js-drawer");

   function showPopup(milliseconds=0) {
      var popupShownDate = localStorage.getItem("notification_drawer");
      var epochTime = new Date().valueOf();
      var twentyFourHoursInMilliseconds = 86400000;

      // Only show the pop-up if it hasn't been shown in the last 24 hours
      if(!popupShownDate || (parseInt(popupShownDate) + twentyFourHoursInMilliseconds) <= epochTime) {
         setTimeout(function() {

            // Show the popup
             if(popup){
                 popup.classList.add("is-open");
                 togglePopupModal(true);
             }


            localStorage.setItem("notification_drawer", epochTime);

            // Code to show pop-up goes here
            // $('.js-drawer').addClass('is-open');

         }, milliseconds); // Delay pop-up for 2 seconds. Set this to 0 for no delay.
      }
   }

   // Large modal variant: lock the page behind while it's open
   function togglePopupModal(isOpen) {
      if(popup && popup.classList.contains("popup-drawer--fullscreen")) {
         document.body.classList.toggle("has-popup-modal", isOpen);
      }
   }

   // function hidePopup() {
   //    popup.classList.remove("is-open");
   // }

   // Show the pop-up after a specific amount of time.
   // If you'd like to show it immediately, simply leave the `milliseconds`
   // parameter blank, like so: showPopup();
   showPopup(2000);

   const drawerCloseElm = document.querySelector(".js-drawer-close");
   if(drawerCloseElm){
       drawerCloseElm.addEventListener('click', function() {
           popup.classList.remove("is-open");
           togglePopupModal(false);
       });
   }

   // Large modal variant: clicking outside the content closes it
   if(popup && popup.classList.contains("popup-drawer--fullscreen")){
       document.addEventListener('click', function(e) {
           if(popup.classList.contains("is-open") && !popup.contains(e.target)) {
               popup.classList.remove("is-open");
               togglePopupModal(false);
           }
       });
   }
}
